import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Capacitor } from "@capacitor/core";


@Component({
    selector: 'update-dialog',
    templateUrl: 'update-dialog.component.html',
})

export class UpdateDialog {

    skipFlag: any;
    constructor(public dialogRef: MatDialogRef<UpdateDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.skipFlag = data.skipFlag;
    }

    onClickupdate(): void {
        if (Capacitor.getPlatform() === 'ios') {
            window.open('https://apps.apple.com/us/app/dhaduk-parivar/id6499073455', '_blank');
        }
        else {
            window.open('https://play.google.com/store/apps/details?id=dhaduk.parivar', '_blank');
        }
    }

}